var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneblue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.25737C2 2.59463 2.53726 2.05737 3.2 2.05737H5.78345C6.37005 2.05737 6.87068 2.48147 6.96712 3.06009L7.85429 8.38314C7.9409 8.90278 7.67847 9.41814 7.20728 9.65373L5.34951 10.5826C6.68907 13.9114 9.34602 16.5683 12.6748 17.9079L13.6036 16.0501C13.8392 15.5789 14.3546 15.3165 14.8742 15.4031L20.1973 16.2903C20.7759 16.3867 21.2 16.8873 21.2 17.4739V20.0574C21.2 20.7201 20.6627 21.2574 20 21.2574H17.6C8.98436 21.2574 2 14.273 2 5.65737V3.25737Z",
    fill: "#2499F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneblue);
export default __webpack_public_path__ + "static/media/phoneblue.01b23d0939a4cbc96a8adcab5a72e41c.svg";
export { ForwardRef as ReactComponent };